import React from "react";

import Tabela from "../comum/Tabela";
import { reais } from "../comum/formato";
import { STATUS_CAMPANHA, retornoX } from "./api";

export default function AnunciosDaCampanha({ anuncios }) {
  const colunas = [
    { id: "nome", rotulo: "Anúncio", valor: (a) => a.nome, render: (a) => (
      <div className="flex items-center gap-2 min-w-0">
        {a.imagem_url && <img src={a.imagem_url} alt="" className="w-9 h-9 rounded object-cover shrink-0" />}
        <div className="min-w-0"><b className="block truncate max-w-[240px]">{a.nome || a.meta_ad_id || "—"}</b>
          {a.texto && <span className="block text-[11px] text-muted-foreground truncate max-w-[240px]">{a.texto}</span>}</div>
      </div>) },
    { id: "status", rotulo: "Status", valor: (a) => a.effective_status || a.status, render: (a) => {
      const [r, cor] = STATUS_CAMPANHA[a.effective_status || a.status] || [a.effective_status || a.status || "—", "text-muted-foreground"];
      return <span className={`text-xs ${cor}`} title={a.motivo_reprovacao || ""}>{r}{a.motivo_reprovacao ? " ⚠" : ""}</span>; } },
    { id: "investido", rotulo: "Investido", alinhar: "direita", valor: (a) => a.investido, render: (a) => reais(a.investido) },
    { id: "cliques", rotulo: "Cliques", alinhar: "direita", valor: (a) => a.cliques, render: (a) => a.cliques },
    { id: "pedidos", rotulo: "Pedidos", alinhar: "direita", valor: (a) => a.pedidos, render: (a) => <b>{a.pedidos}</b> },
    { id: "faturado", rotulo: "Faturado", alinhar: "direita", valor: (a) => a.faturado, render: (a) => reais(a.faturado) },
    { id: "retorno", rotulo: "ROI", alinhar: "direita", valor: (a) => a.retorno, render: (a) => <b>{retornoX(a.retorno)}</b> },
  ];
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5">
      <h3 className="font-semibold mb-2">Anúncios desta campanha</h3>
      <Tabela colunas={colunas} linhas={anuncios || []} ordemInicial={{ id: "investido", desc: true }} vazio="Nenhum anúncio lido da Meta para esta campanha." e2e="tabela-anuncios-meta" chave={(a, i) => a.meta_ad_id || i} />
      {(anuncios || []).some((a) => a.motivo_reprovacao) && (
        <p className="text-[11px] text-amber-600 mt-2">⚠ Anúncio reprovado pela Meta — passe o mouse no status para ver o motivo.</p>
      )}
    </section>
  );
}
